import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import React, { forwardRef, useEffect, useState } from "react";

const Header = (props, ref) => {
	let scrollTl = null;
	let [hasTouch, setHasTouch] = useState(false);

	const isTouchDevice = () =>
		"ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

	useEffect(() => {
		setHasTouch(isTouchDevice());

		gsap.fromTo(ref.current, { autoAlpha: 0 }, { autoAlpha: 1 });
		scrollTl = gsap.timeline({
			scrollTrigger: {
				trigger: ref.current,
				invalidateOnRefresh: true,
				start: () => `top top`,
				end: () => "bottom-=20% top",
				markers: false,
				scrub: 0.2, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			},
		});
		scrollTl.fromTo(ref.current, { autoAlpha: 1 }, { autoAlpha: 0 });
	});

	return (
		<div className="about-header" ref={ref}>
			<h2 className="about-header__heading">
				How do you take something as beautifully abstract and infuriatingly unpredictable as an idea and distill
				it into numbers that actually mean something?
			</h2>
			<button className="about-header__scroll-indicator">
				<p>{hasTouch ? "Scroll" : "Scroll"}</p>
				<svg
					className={hasTouch ? "rotate" : ""}
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M10.4848 0.000244141L13.5152 0.000244141L13.5152 18.1821L21.8485 9.84873L24 12.0002L12 24.0002L0 12.0002L2.15152 9.84873L10.4848 18.1821L10.4848 0.000244141Z"
						fill="white"
					/>
				</svg>
			</button>
		</div>
	);
};

export default forwardRef(Header);
